// import workBench from './workBench'
import order from './order'
import member from './member'
import data from './data'
import money from './money'
import goods from './goods'
import market from './market'
import store from './store'
import setting from './setting'

// 首页布局
const index = () => import(/* webpackChunkName: 'homeIndex' */ '@views/home/index/index')

const routes = [
  {
    path: '/',
    component: index,
    redirect: '/workbench',
    hideen: true,
    name: 'workhome',
    meta: {
      keepAlive: true,
      title: '工作台',
      first: true,
      resourceCode: 'WORKBENCH_MANAGE',
      icon: 'workbench_manage',
      No: 0
    },
    children: [
      {
        hideen: true,
        path: '/workbench',
        component: () => import('@views/home/workbench/index'),
        name: 'workbench',
        meta: { keepAlive: true, title: '工作台', first: true, resourceCode: '' }
      }
    ]
  },
  ...order.routes,
  ...member.routes,
  ...data.routes,
  ...money.routes,
  ...goods.routes,
  ...market.routes,
  ...store.routes,
  ...setting.routes
]
export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/home/index.js